<template>
  <div>
    <listado-descuentos-clientes-tabla
      :data="data"
      :getListaDescuentosClientes="getListaDescuentosClientes"
      :dataInicial="dataInicial"
    />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import { getDescuentosClientes } from "@/constants/lineas";

import ListadoDescuentosClientesTabla from "../../../components/tablas/lineas/ListadoDescuentosClientesTabla";

export default {
  components: { ListadoDescuentosClientesTabla },
  data() {
    return {
      data: [],
      dataInicial: [],
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", [
      "dataDatatableTarifasDescuentosClientesFiltrada"
    ]),
  },
  methods: {
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoadingTable",
      "ActionSetClientes",
      "ActionSetNavieras",
      "ActionSetTipoContratos",
      "ActionSetContenedores",
      "ActionSetCommodity",
      "ActionSetContratos",
      "ActionSetPol",
      "ActionSetPod",
      "ActionSetShowDescuentosClientes"
    ]),
    // Acciones de Vuex
    ...mapActions("lineas", [
      "actionSetDataListarTarifasDescuentosClientes",
      "actionSetDataContenedores",
      "actionSetDataListaNavierasNoUCC"
    ]),

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },

    async getListaDescuentosClientes() {

      this.ActionSetShowDescuentosClientes(false);

      this.data = [];

      this.ActionSetLoadingTable(true);

      const {
        data_table,
        filtros_clientes,
        filtros_contenedor,
        filtros_contratos,
        filtros_navieras,
        filtros_navieras_no_ucc,
        filtros_pod,
        filtros_pol,
        filtros_productos
      } = await getDescuentosClientes(this.token);

      this.data = data_table;
      this.dataInicial = data_table;
      this.actionSetDataListarTarifasDescuentosClientes(data_table);
      this.ActionSetClientes(filtros_clientes);
      this.ActionSetNavieras(filtros_navieras);
      this.actionSetDataListaNavierasNoUCC(filtros_navieras_no_ucc);
      this.ActionSetContenedores(filtros_contenedor);
      this.ActionSetCommodity(filtros_productos);
      this.ActionSetContratos(filtros_contratos);
      this.ActionSetPol(filtros_pol);
      this.ActionSetPod(filtros_pod);
      this.actionSetDataContenedores(filtros_contenedor);
      this.ActionSetLoadingTable(false);
    }
  },
  created() {
    this.getListaDescuentosClientes();
    this.actualizarURL();
  },
  watch: {
    dataDatatableTarifasDescuentosClientesFiltrada: function (_new) {
      if (_new) {
        this.data = _new;
      }
    },
  },
};
</script>
<style></style>
